import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class EventService {

   /* private lookupSubject = new ReplaySubject()<Lookup[]>(1);
    lookupObservable = this.lookupSubject.asObservable();

    publishLookupData(data) {
        return this.lookupSubject.next(data);
    }

    getLookupData() {
        return this.lookupObservable;
    }*/
}
